var _path, _path2, _rect, _line, _line2, _path3, _path4, _path5, _circle, _line3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestScanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 200,
    viewBox: "0 0 316 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.921 16.2044C169.921 19.8214 168.498 24.3971 166.143 28.0562C163.741 31.7898 160.77 33.9882 157.938 33.9882C155.106 33.9882 152.135 31.7898 149.732 28.0562C147.378 24.3971 145.955 19.8214 145.955 16.2044C145.955 9.10229 151.412 3.51514 157.938 3.51514C164.464 3.51514 169.921 9.10229 169.921 16.2044Z",
    stroke: "#D8E3FF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.733 70.0476C138.733 70.0476 126.63 138.202 121.503 178.424C121.28 180.173 123.638 180.753 124.287 179.115L151.555 110.357C152.594 107.738 155.126 106.018 157.943 106.018V106.018C160.754 106.018 163.282 107.73 164.325 110.34L191.612 178.639C192.27 180.286 194.654 179.667 194.411 177.911C188.844 137.627 176.89 70.0476 176.89 70.0476M214.06 90.8219L181.359 47.9546C179.639 45.7003 176.966 44.3774 174.131 44.3774H141.489C138.655 44.3774 135.983 45.6988 134.264 47.951L101.938 90.2825",
    stroke: "#D8E3FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.575,
    y: 81.8184,
    width: 84.8485,
    height: 116.667,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 211.515,
    y1: 173.757,
    x2: 298.424,
    y2: 173.757,
    stroke: "#D8E3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.5752,
    y1: 173.757,
    x2: 104.484,
    y2: 173.757,
    stroke: "#D8E3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.333 94.0885V89.3932C191.333 84.3724 187.263 80.3022 182.242 80.3022H133.757C128.736 80.3022 124.666 84.3724 124.666 89.3932V180.302C124.666 185.323 128.736 189.393 133.757 189.393H182.242C187.263 189.393 191.333 185.323 191.333 180.302V127.392",
    stroke: "url(#paint0_linear_1054_6680)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.129 96.6462C162.129 97.8844 161.611 99.5284 160.724 100.857C159.807 102.23 158.788 102.859 157.975 102.859C157.163 102.859 156.144 102.23 155.227 100.857C154.339 99.5284 153.822 97.8844 153.822 96.6462C153.822 94.2966 155.699 92.4234 157.975 92.4234C160.252 92.4234 162.129 94.2966 162.129 96.6462Z",
    stroke: "url(#paint1_linear_1054_6680)",
    strokeWidth: 3.0303,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.189 120.045C150.189 120.045 146.43 140.441 144.099 156.064C143.84 157.799 146.086 158.391 146.753 156.769L155.365 135.846C155.8 134.787 156.832 134.096 157.977 134.096V134.096C159.119 134.096 160.149 134.784 160.587 135.839L169.074 156.308C169.75 157.939 172.038 157.317 171.765 155.572C169.325 140.017 165.658 120.045 165.658 120.045M180.727 126.385L169.094 111.69C167.369 109.512 164.744 108.242 161.966 108.242H153.879C151.102 108.242 148.478 109.511 146.754 111.687L135.272 126.174",
    stroke: "url(#paint2_linear_1054_6680)",
    strokeWidth: 3.0303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.999,
    cy: 174.242,
    r: 6.06061,
    fill: "url(#paint3_linear_1054_6680)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 191.06,
    y1: 103.515,
    x2: 191.06,
    y2: 117.697,
    stroke: "url(#paint4_linear_1054_6680)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1054_6680",
    x1: 157.999,
    y1: 80.3022,
    x2: 157.999,
    y2: 189.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#A28BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C58BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1054_6680",
    x1: 157.975,
    y1: 80.5,
    x2: 157.975,
    y2: 189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A28BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C58BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1054_6680",
    x1: 158,
    y1: 80,
    x2: 158,
    y2: 189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A28BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C58BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1054_6680",
    x1: 157.999,
    y1: 81.5,
    x2: 157.999,
    y2: 193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A28BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C58BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1054_6680",
    x1: 159.999,
    y1: 79,
    x2: 159.999,
    y2: 193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A28BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C58BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestScanIcon);
export default __webpack_public_path__ + "static/media/request-scan-icon.35d276039064fd06344a692486e3c889.svg";
export { ForwardRef as ReactComponent };